var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"onlyoffice-wrapper",style:(_vm.containerStyle)},[_c('div',{staticClass:"onlyoffice-content",style:({ width: '100%', height: '100%' }),attrs:{"id":_vm.containerId}})])
}
var staticRenderFns = []

export { render, staticRenderFns }